export const USD = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD'
})

/**
 * Accepts an array of price strings in dollars and returns the total in cents.
 * @param {Array<string>} prices
 * @returns {number}
 */
export const calculateTotalCents = (prices) => {
  if (!Array.isArray(prices)) {
    throw new Error('Prices must be an array')
  }

  return prices.reduce((sum, price) => {
    const cents = Math.round(parseFloat(price) * 100)
    if (isNaN(cents)) {
      throw new Error(`Invalid price value: ${price}`)
    }
    return sum + cents
  }, 0)
}
